module.exports = __webpack_public_path__ + "img/chest.21ea2ed2.png";